import React from 'react';
import { Star } from 'lucide-react';
import { Testimonial } from '../../pages/landing/constants';

interface SocialProofSectionProps {
  testimonials: Testimonial[];
  title?: string;
  layout?: 'grid' | 'carousel';
  columns?: 2 | 3;
}

export default function SocialProofSection({
  testimonials,
  title = "What Our Growers Are Saying",
  layout = 'grid',
  columns = 3
}: SocialProofSectionProps) {
  const gridClass = columns === 2 ? 'md:grid-cols-2' : 'md:grid-cols-3';

  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            {title}
          </h2>
        </div>

        <div className={`grid grid-cols-1 ${gridClass} gap-8 max-w-6xl mx-auto`}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <p className="text-gray-700 mb-4 italic">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-gray-200"></div>
                <div>
                  <p className="font-semibold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.zone}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
